// interface AppContainerProps {
//   children: React.ReactNode;
// }

const AppContainer = ({ children }) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--bg-color)]">
      <div className="flex min-h-screen w-screen max-w-[var(--max-width)] flex-col items-center justify-center bg-[var(--app-bg-color)]">
        {children}
      </div>
    </div>
  );
};

export default AppContainer;
